module.exports = __webpack_public_path__ + "img/emblem2.039e17cb.png";